import { Navigate } from 'react-router-dom';

// O `/student` não tem tela própria: sem índice, o `<Outlet />` do `StudentLayout` fica vazio.
export const studentIndexRoute = {
  index: true,
  element: <Navigate to="courses" replace />,
};
